// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb7d5e1f","239":"68c1023d","732":"c76bb17e"}[chunkId] + ".chunk.js";
};